// Flow lockup — "flow" over "by other" (CEO 2026-10-12: Flow is its own system).
//
// Matched to the CEO's login design (2026-10-12), measured to the pixel:
//   "flow"       DM Sans 700 (the app's own face — the design's f/l/o/w), normal spacing
//   "by other"   left-aligned under it, 74% of "flow"'s width
//   "other"      the approved wordmark (docs/brand/other-vector-art, never redrawn),
//                54% of "flow"'s width, its height 43% of "flow"'s letter height
//   "by"         DM Sans 400, sitting on "other"'s baseline
//   baselines    66% of "flow"'s letter height apart
// Geometry in viewBox units with "flow" at font-size 100 (ink 186.8 wide, 70
// tall). One SVG, so the proportions hold at any size: give it a width.
// Colour follows the text colour (currentColor).
interface FlowLockupProps {
  /** Rendered width in px (height follows the artwork's ratio). */
  width?: number;
  className?: string;
}

const VB_W = 188;
const VB_H = 128;

export function FlowLockup({ width = 112, className }: FlowLockupProps) {
  return (
    <svg
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      width={width}
      height={Math.round((width * VB_H) / VB_W)}
      className={className}
      role="img"
      aria-label="flow by other"
      fill="currentColor"
    >
      <text x="1" y="70" fontFamily='"DM Sans", Arial, sans-serif' fontWeight={700} fontSize={100}>
        flow
      </text>
      <text x="1.5" y="120" fontFamily='"DM Sans", Arial, sans-serif' fontWeight={400} fontSize={30}>
        by
      </text>
      {/* other — the approved wordmark (332 × 103 units) at 0.31 */}
      <g transform="translate(39 88.1) scale(0.31)" fillRule="evenodd">
        <path d="M40.5 29 C17.5 29 0 44.3 0 66 C0 87.7 17.5 103 40.5 103 C63.5 103 81 87.7 81 66 C81 44.3 63.5 29 40.5 29 Z M40.5 49 C50.8 49 58 56 58 66 C58 76 50.8 83 40.5 83 C30.2 83 23 76 23 66 C23 56 30.2 49 40.5 49 Z" />
        <path d="M85 15 H107 V31 H126 V49 H107 V69 C107 79.5 113 83 126 83 V103 C98 103 85 92 85 69 Z" />
        <path d="M130 0 H152 V40 C157.8 32.5 165.5 29 175 29 C194 29 203 41.6 203 62 V103 H181 V66 C181 54.7 176.7 49 167.5 49 C158.3 49 152 55.4 152 67 V103 H130 Z" />
        <path d="M243.5 29 C221.4 29 206 44.3 206 66 C206 88.3 221.7 103 244.5 103 C262.2 103 275.1 94.3 280 80 H258 C255 84.7 250.5 87 244.5 87 C234.9 87 228.7 81.9 227 73 H281 V65 C281 43.3 266.9 29 243.5 29 Z M227.5 57 C229.9 48.4 235.6 44 243.5 44 C251.8 44 257.6 48.5 259.5 57 Z" />
        <path d="M285 31 H307 V43 C312.7 33.7 320.7 29 332 29 V51 C316.4 51 307 59 307 75 V103 H285 Z" />
      </g>
    </svg>
  );
}
